import { AskAiProduct } from '@/creditflowresearch/domain/vo/AskAiChat';

const HEADING_PATTERNS: Record<AskAiProduct, RegExp> = {
  abs: /^#{1,3}\s+(ABS|Asset-backed)\b/i,
  corp: /^#{1,3}\s+(Corp(orate)?|Investment Grade)\b/i,
};

const ANY_HEADING = /^#{1,3}\s+/;

const isProductHeading = (line: string, product: AskAiProduct): boolean =>
  HEADING_PATTERNS[product].test(line);

const getHeadingProduct = (line: string): AskAiProduct | null => {
  if (isProductHeading(line, 'abs')) {
    return 'abs';
  }

  if (isProductHeading(line, 'corp')) {
    return 'corp';
  }

  return null;
};

export const getProductAtLine = (content: string, line: number): AskAiProduct | null => {
  const linesBefore = content.split('\n').slice(0, line - 1);

  return linesBefore.reduce<AskAiProduct | null>((product, text) => {
    return getHeadingProduct(text) ?? product;
  }, null);
};

export const getProductSections = (content: string): AskAiProduct[] => {
  if (!content) return [];

  const lines = content.split('\n');
  const products: AskAiProduct[] = [];

  for (const line of lines) {
    if (!ANY_HEADING.test(line)) continue;

    if (isProductHeading(line, 'abs') && !products.includes('abs')) {
      products.push('abs');
    } else if (isProductHeading(line, 'corp') && !products.includes('corp')) {
      products.push('corp');
    }
  }

  return products;
};
